// @flow
import React from 'react';
import USBModal, { ModalHeader, ModalBody, ModalFooter } from '@usb-shield/react-modal';
import {
    USBButtonGroup, USBButton
} from '@usb-shield/components-react/dist/cjs';
import AutoCompleteDropdown from '../shared/AutoCompleteDropdown/AutoCompleteDropdown';


type MoveDialogProps = {
    open: boolean,
    title: String,
    toggle: () => void,
    profile: Object,
    pcList : Array,
    primaryButtonText: String,
    primaryClickHandler: () => void
}
const MoveDialog = (props) => {

    return (
        <USBModal
            id='move-dialog'
            isOpen={props.open}
            handleClose={props.toggle}
        >
            <ModalHeader id='move-dialog-header'>
                {props.title}
            </ModalHeader>

            <ModalBody>
                <div>
                    <div style={{fontWeight:'bolder'}}>User Details</div>
                    <div>
                        <span style={{fontWeight:'bolder'}}>Full Name :</span>
                        <span>{` ${props.profile?.user?.firstName}  ${props.profile?.user?.lastName}`}</span> 
                    </div>
                    <div>
                        <span style={{fontWeight:'bolder'}}>Email :</span>
                        <span>{` ${props.profile?.user?.email}`}</span> 
                    </div>
                    <div>
                        <span style={{fontWeight:'bolder'}}>Role :</span>
                        <span>{` ${props.profile?.user?.profileRole}`}</span> 
                    </div>
                    <br></br>
                    <div style={{fontWeight:'bolder'}}>Company Details</div>
                    <div>
                        <span style={{fontWeight:'bolder'}}>Moving From :</span>
                        <span>{` ${props.profile?.user?.parentCompanyName}`}</span> 
                    </div>
                    <div>
                        <span style={{fontWeight:'bolder'}}>Profile Type :</span>
                        <span>{` ${props.profile?.company?.businessProfileType}`}</span> 
                    </div>
                </div>
                <div style={{fontWeight:'bolder'}}>Moving To :</div>
                <div className='move-user-autocomplete'>
                    <AutoCompleteDropdown
                      onItemSelect={(e) => props.getPermissionsWithEin(e)}
                      comboboxId="combobox"
                      autocompleteInputId="autocomplete-input"
                      listboxID="listbox"
                      arrowId="combobox-arrow"
                      listItems={props.pcList.slice(1,-1).map(parent=>{return {...parent, term: parent.content}})}
                      label = "Parent company"
                    />
                </div>
                <br/>
                <div>
                    {props.profile?.profileRole == 'Site Administrator' ? 'The user will have access to all current and future reporting requirements' : 'The user will have access to all current and future reporting requirements'}
                </div>
                {/* <div>{JSON.stringify(props?.newParentPermissions)}</div> */}
                
                
            </ModalBody>
            <ModalFooter>
                <USBButtonGroup>
                    <USBButton
                        variant='secondary'
                        // handleClick={props.cancelHandler}
                        handleClick = {props.toggle}
                        ariaLabel='close modal'
                    >
                        Cancel
                    </USBButton>
                    <USBButton
                        dataTestId={'moveUserPrimaryButton'}
                        title={props.primaryButtonText}
                        variant='primary'
                        id={'moveUserPrimaryButton'}
                        addClasses={'move-button'}
                        handleClick={()=>{props.primaryClickHandler(props?.profile,props)}}
                        ariaLabel={props.primaryButtonText}
                    >
                        {props.primaryButtonText}
                    </USBButton>
                </USBButtonGroup>
            </ModalFooter>
        </USBModal>
    )
}

export default MoveDialog;